import React, { useState } from 'react';
import { Button, Col, Form, Input, message, Row } from 'antd';

import {
  checkEmailService,
  checkPhoneService,
  sendCaptchaByEmail,
  sendCaptchaByPhone,
  settingPwdService,
} from '../services';
import { autoCompletePhone, getNodeId, isEmail, passwordPattern } from '../utils';
import { useCountDownCustom } from './hooks';

import './index.less';

const FormSetPwd = (props: any) => {
  let client_id = getNodeId();
  const { isUpdStatus } = props;
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(true);
  const [codeBtnLoading, setCodeBtnLoading] = useState(false);

  // 全局状态
  const [form] = Form.useForm();

  const { codeBtnDisabled, btnContent, enable, setEnable, startCountDown } = useCountDownCustom();

  const checkIsExistEmail = async (value: any, type = 'email') => {
    try {
      const payload = { email: value };
      const data = await checkEmailService(payload);

      if (data?.isExist) {
        return true;
      } else {
        form.setFields([
          {
            name: type,
            errors: ['邮箱需要先注册'],
          },
        ]);
        return false;
      }
    } catch (e) {}
  };

  const checkIsExistPhone = async (value: any, type = 'phone') => {
    try {
      const payload = { phone: autoCompletePhone(value) };
      const result = await checkPhoneService(payload);
      if (result && result.data) {
        if (!result?.data?.isExist) {
          form.setFields([
            {
              name: type,
              errors: ['手机需要先注册'],
            },
          ]);
        }
        return result.data.isExist;
      }
      return false;
    } catch (e) {}
  };

  // 发送短信验证
  const onSendCode = async () => {
    setCodeBtnLoading(true);
    try {
      const formValues = form.getFieldsValue();

      // 判断是邮箱还是手机号
      const isEmailFlag = isEmail(formValues?.username || '');
      const username = isEmailFlag ? formValues?.username : autoCompletePhone(formValues?.username);

      if (isEmailFlag) {
        if (!checkIsExistEmail(username, 'username')) return;
      } else {
        if (!checkIsExistPhone(username, 'username')) return;
      }

      let data = null;

      if (!isEmailFlag) {
        data = await sendCaptchaByPhone({
          phone: username,
        });
      } else {
        data = await sendCaptchaByEmail({
          email: username,
        });
      }

      try {
        if (data?.error) {
          // message.error(data?.error);
          throw new Error(data?.msg);
        } else {
          // 开始倒计时
          // setAccountLastTime(new Date().getTime());
          startCountDown();
          message.success('验证码发送成功，请查收!');
        }
      } catch (e) {
        if (e?.message === '60秒内不能发送多次验证码') {
          message.error(e?.message);
        } else {
          message.error('验证码发送失败，请稍候重试!');
        }
      }
    } catch (error) {
    } finally {
      setCodeBtnLoading(false);
    }
  };

  const onFinish = async (values: any) => {
    const { username, code, password } = values;
    const isEmailFlag = isEmail(username);
    const payload = {
      code,
      password,
      username: isEmailFlag ? username : autoCompletePhone(username), // +86
      kind: isEmailFlag ? 2 : 3,
      client_id,
    };

    setLoadingBtn(true);
    const result = await settingPwdService(payload);
    setLoadingBtn(false);
    let errorText = isUpdStatus ? '修改密码失败' : '找回密码失败';
    try {
      if (result?.error) {
        errorText = result?.msg;
        props?.updPasswordSuccess?.(false, errorText);
        showMesageError(errorText); // 错误提示
        return;
      }
      onSuccess(isUpdStatus); // 修改成功回调
    } catch (e) {
      props?.updPasswordSuccess?.(false, errorText);
      showMesageError(errorText); // 异常提示
    }
  };

  //错误提示
  function showMesageError(content: string) {
    message.error({
      content: content,
      key: 'pwdUpdError',
    });
  }

  //  修改成功回调
  function onSuccess(isUpdStatus1: any) {
    message.success(isUpdStatus1 ? `修改密码成功` : '找回密码成功');
    setTimeout(() => {
      if (isUpdStatus1) {
        props?.updPasswordSuccess?.(); // 修改成功回调
        props?.onClose?.();
      } else {
        props?.findBackPasswordSuccess?.(); // 成功回调
      }
    }, 1000);
  }

  const handleFieldsChange = (fields, allFields) => {
    let isDisabledCheck = false;
    for (let fieldItem of allFields) {
      if (fieldItem.name[0] === 'username') {
        if (fieldItem.errors?.length) {
          setEnable(false);
        } else {
          setEnable(true);
        }
      }
      if (
        fieldItem?.name[0] !== 'agreement' &&
        (!fieldItem?.touched || fieldItem?.errors?.length)
      ) {
        isDisabledCheck = true;
        break;
      }
    }
    setIsDisabledSubmit(isDisabledCheck);
  };

  return (
    <>
      <div className={'headerGroup'}>
        <div>{isUpdStatus ? '修改密码' : '找回密码'}</div>
      </div>
      <div className={'loginForm'}>
        <Form
          form={form}
          size={'large'}
          name="register"
          onFinish={onFinish}
          onFieldsChange={handleFieldsChange}
          scrollToFirstError
        >
          <input
            type="password"
            style={{ width: 0, height: 0, display: 'block', transform: 'translateY(12px)' }}
          />
          <Form.Item
            name="username"
            label=""
            rules={[
              {
                required: true,
                message: '请输入邮箱或手机号',
              },
              {
                pattern: /^1[23456789]\d{9}$|\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                message: '请输入正确的邮箱或手机号',
              },
            ]}
          >
            <Input placeholder={'请输入邮箱或手机号'} />
          </Form.Item>

          <Form.Item label="">
            <Row gutter={8}>
              <Col span={12}>
                <Form.Item
                  name="code"
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: '请输入验证码',
                    },
                    {
                      pattern: /^[0-9]{6}$/,
                      message: '请输入正确的验证码',
                    },
                  ]}
                >
                  <Input placeholder={'请输入验证码'} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Button
                  className="codeBtn"
                  loading={codeBtnLoading}
                  type={enable ? 'primary' : 'default'}
                  block
                  disabled={codeBtnDisabled}
                  onClick={onSendCode}
                >
                  {btnContent}
                </Button>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item
            name="password"
            label=""
            rules={[
              {
                required: true,
                message: '请填写密码',
              },
              {
                pattern: passwordPattern,
                message: '密码至少8位，并且包含数字和字母组合',
              },
            ]}
          >
            <Input.Password
              visibilityToggle={false}
              placeholder={'请输入密码（至少8位，数字字母组合）'}
            />
          </Form.Item>

          <Form.Item
            name="confirm"
            dependencies={['password']}
            label=""
            rules={[
              {
                required: true,
                message: '请再次输入密码',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次密码输入不一致'));
                },
              }),
            ]}
          >
            <Input.Password visibilityToggle={false} placeholder={'请再次输入密码'} />
          </Form.Item>

          <Form.Item>
            <Button
              disabled={isDisabledSubmit}
              type="primary"
              htmlType="submit"
              loading={loadingBtn}
              block
            >
              确认
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default FormSetPwd;
